import api from './api';
import dynamicUiText from '@/helpers/dynamicUiText';
import { useTerminologyStore } from '@/store/terminologyStore';
import { useloggedUserInfo } from "../store/UserInfo";

class userAuthService {
    async getCurrentUserDetail(userId, actionType) {
        let optionaParamersType = "00Test";
        let info;
        var TimeZone;
        await api.get(`UserProfile/GetUserInfo/${userId}/${actionType}/${optionaParamersType}`).then(response => {
            info = response,
                useloggedUserInfo().setUser(info.data),

                localStorage.removeItem('userinfo'),
                localStorage.removeItem("dashboardItems"),
                localStorage.setItem("dashboardItems", "True"),
                localStorage.setItem('userinfo', JSON.stringify(response)),
                localStorage.removeItem('companyId'),
                localStorage.removeItem('themeName'),

                localStorage.removeItem('isWizard'),

                localStorage.setItem("companyId", response.data.companyId),

                localStorage.removeItem('SettingObserver'),
                localStorage.setItem("SettingObserver", response.observerSettingName),
                localStorage.removeItem('SettingEmployee'),
                localStorage.setItem("SettingEmployee", response.employeeSettingName),
                localStorage.removeItem('TimeZone'),
                TimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone, //response.timeZone;
                //'America/New_York'
                localStorage.setItem("TimeZone", response.data.timeZone),
                localStorage.setItem("TimeZoneText", response.data.timeZoneText),

                localStorage.setItem('sliderMenu', JSON.stringify(1)),
                localStorage.setItem("usersucess", "yes"),

                localStorage.removeItem('primaryLogo'),
                localStorage.removeItem('secondaryLogo'),
                localStorage.removeItem('companyName'),
                localStorage.removeItem('encryptedEmail'),
                localStorage.removeItem('encryptedPhoneNumber'),
                localStorage.removeItem('assetType'),
                localStorage.removeItem('ucaasVerification'),
                //Currency
                localStorage.removeItem('currency'),
                localStorage.setItem("primaryLogo", response.data.primaryLogo),
                localStorage.setItem("currency", response.data.currency),
                localStorage.setItem("secondaryLogo", response.data.secondaryLogo),
                localStorage.setItem("companyName", response.data.companyName),
                localStorage.setItem("themeName", response.data.themeName),
                localStorage.setItem("isWizard", response.data.isWizard),
                localStorage.setItem("isAssetAssigned", response.data.isAssetAssigned),
                localStorage.setItem("ucaasVerification", response.data.ucaasVerification),

                localStorage.setItem("encryptedEmail", response.data.encryptedEmail),
                localStorage.setItem("encryptedPhoneNumber", response.data.encryptedPhoneNumber);
                if (localStorage.getItem('companyId') === '29E9C4AD-9AF2-4757-A001-AC34690B1A12') {
                localStorage.setItem('assetType', '');
            } else {
                localStorage.setItem('assetType', response.data.assetType);
            }
                
            dynamicUiText.clearTerminologyCache(),
            useTerminologyStore().syncFromStorage(),
            localStorage.setItem("userType", response.data.userType);
            if (localStorage.getItem('Language') == 'en' || localStorage.getItem('Language') ==null) {
            localStorage.setItem("Language", 'en');
            localStorage.setItem("LanguageId", '364697eb-c5d6-44fa-8c08-ece45aed1844');
            } else {
            localStorage.setItem("Language", 'spanish');
            localStorage.setItem("LanguageId", 'cdf82d9b-07af-427e-9261-a3f45bc98f8f');
            }

        })
        return info;
    }
    async GetUser(userId, actionType) {
        let optionaParamersType = "00Test";
        return await api.get(`UserProfile/GetUserInfo/${userId}/${actionType}/${optionaParamersType}`);
    }

    async GetModuleList(userId, opType) {
        var loginSource = localStorage.getItem('loginSource');
        return await api.get(`Module/GetModuleList/${userId}/${opType}/${loginSource}`);
    }

    async GetCompanyUserInfo(CompanyUserLoginInfo) {
        return await api.post(`Account/GetCompanyUserInfo`, CompanyUserLoginInfo);
    }

    getUserModulePermissions(userId, actionType) {
        if (actionType == '' || actionType == null || typeof actionType == undefined) {
            actionType = '00Test';
        }
        if (localStorage.getItem("actionType") == 'AsAObserver') {
            actionType = localStorage.getItem("actionType");
        }
        let loginSource = localStorage.getItem('loginSource');
        return api.get(`common/GetUserModulePermissionList/${userId}/${loginSource}`);
    }
}

export default new userAuthService();